import { Component, inject, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

import { take } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

import { ConfigService, BreadcrumbService } from 'app/shared/services';
import { MenuItem } from 'app/shared/models';


@Component({
  selector: 'app-sidebar-content',
  imports: [RouterLink, RouterLinkActive, TranslateModule],
  templateUrl: './sidebar-content.html',
  styleUrl: './sidebar-content.scss',
})
export class SidebarContent {

  private readonly configService = inject(ConfigService);
  private readonly breadcrumbService = inject(BreadcrumbService);

  readonly collapsed = input.required<boolean>();

  readonly offset = input<boolean>(false);

  menuItems: MenuItem[] = [];

  constructor() {
    this.configService
      .select('menu')
      .pipe(take(1))
      .subscribe((value: MenuItem[]) => {
        this.menuItems = value.filter(menuItem => menuItem.position === "sidebar");
        this.breadcrumbService.setMenu(value);
      });
  }

  onClose = input<(() => void) | undefined>(undefined);

  closeOffset(): void {
    this.onClose()?.();
  }
}
